// ReferenceJob carries referenceId where Job carries taskId; instanceof is unusable in mocked tests
export function isReferenceJob(job: unknown): boolean {
    return !!job && typeof job === 'object' && typeof (job as { referenceId?: unknown }).referenceId === 'number';
}
